import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import { PasswordChangeParam } from '../../models/gen/passwordChangeParam';
import { useGenericMutation } from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const USER_CONTEXT_NAMES = {
  POST_USER_PASSWORD: 'changePassword',
} as const;

const apis = apiGenerator();

/**
 * POST /user/password
 *
 * @param param -
 * @returns
 */
export const usePostUserPassword = () =>
  useGenericMutation(async (param: PasswordChangeParam) =>
    apis.post(`${env.BASE_API_ENDPOINT}/user/password`, {
      ...queryOptions,
      data: param,
    })
  );
